import {
  AppBar,
  Box,
  Container,
  Link,
  makeStyles,
  Toolbar,
  Typography
} from "@material-ui/core";
import Logo from "./Logo";

const useStyles = makeStyles((theme) => ({
  app: {
    backgroundColor: theme.palette.background.default,
    minHeight: "100%",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
  },
  header: {
    backgroundColor: '#1f1f1f',
  },
  container: {
    margin: "40px auto",
    padding: 0,
  },
  menuButton: {
    marginRight: theme.spacing(2),
  },
  title: {
    fontWeight: 600,
  },
  logo: {
    marginRight: "6px",
  },
  footer: {
    backgroundColor: '#1f1f1f',
  },
}));

const Layout = (props) => {
  const classes = useStyles();

  return (
    <div className={classes.app}>
      <AppBar className={classes.header} position="static">
        <Toolbar>
          <a
            href="/"
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              textDecoration: "none",
              color: "#ffffff",
            }}
          >
            <Logo className={classes.logo} />
            <Typography variant="h4" className={classes.title}>
              Возврат
            </Typography>
          </a>
        </Toolbar>
      </AppBar>
      <Container className={classes.container}>{props.children}</Container>
      <Box component="footer" className={classes.footer}>
        <Toolbar style={{ justifyContent: 'center' }}>
          <Typography variant='body1'>
            <Link href="https://giper.fm/politic" style={{ cursor: 'pointer', color: '#ffffff' }} target="_blank">Политика обработки персональных данных.</Link>
          </Typography>
        </Toolbar>
      </Box>
    </div>
  );
};

export default Layout;
